<script setup>
import { vOnClickOutside } from '@vueuse/components';
import Button from 'dashboard/components-next/button/Button.vue';

defineProps({
  headerTitle: {
    type: String,
    default: '',
  },
  buttonLabel: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['click', 'close']);

const handleButtonClick = () => {
  emit('click');
};
</script>

<template>
  <section class="flex flex-col w-full h-full overflow-hidden bg-n-background dark:bg-n-black">
    <header class="sticky top-0 z-10 px-6 bg-n-background dark:bg-n-black h-5 shrink-0 w-full" />
    <main class="flex-1 px-6 overflow-y-auto bg-n-surface-1 rounded-t-2xl">
      <div class="w-full max-w-5xl mx-auto py-4">
        <div class="flex items-center justify-between w-full h-12 mb-4 border-b border-n-weak pb-2">
          <span class="text-xl font-medium text-n-slate-12">
            {{ headerTitle }}
          </span>
          <div
            v-on-click-outside="[
              () => emit('close'),
              // This will prevent closing the modal when the editor Create link popup is open
              { ignore: ['dialog.ProseMirror-prompt-backdrop'] },
            ]"
            class="relative group/campaign-button"
          >
            <Button
              v-if="buttonLabel"
              :label="buttonLabel"
              icon="i-lucide-plus"
              size="sm"
              class="group-hover/campaign-button:brightness-110"
              @click="handleButtonClick"
            />
            <slot name="action" />
          </div>
        </div>
        <slot name="default" />
      </div>
    </main>
  </section>
</template>
